import { memo, useCallback, useEffect, useState } from "react"
import { GeoJSON, Popup } from "react-leaflet"
import { useTranslation } from 'react-i18next'
import { Typography } from "antd"
import { GET } from '../../../../frameworks/HttpClient'
import { URL_GEOGRAPHY } from '../../../../constants/urls'
import { GeographyLayer, LANGUAGE } from '../../../../constants/string'
import LayerOverlay from '../../../map/layers/overlays/LayerOverlay'


const OverlapAreaOverlay = ({ geometry, types, onLoad }) => {
  const { t, i18n } = useTranslation()
  const [isActive, setIsActive] = useState(false)
  const [layers, setLayers] = useState([])

  const fetchLayer = useCallback(() => {
    if (!isActive) return;
    if (!geometry) return setLayers([]);

    onLoad?.(() => (
      GET(`${URL_GEOGRAPHY.LAYER_OVERLAP}?${types.map(type => `type=${type}`).join('&')}`, { geom: geometry })
        .then(result => setLayers(result.data))
        .catch(() => {})
    ))
  }, [geometry, onLoad, types, isActive])

  useEffect(() => {
    fetchLayer()
    return () => setLayers([])
  }, [fetchLayer])

  return (
    <LayerOverlay
      name='overlap'
      title={t(GeographyLayer.Labels.OVERLAP_AREA)}
      onChange={checked => {
        if (checked) {
          setIsActive(true)
          fetchLayer()
        }
        else {
          setIsActive(false)
          setLayers([])
        }
      }}
    >
      {layers.map(layer => (
        <GeoJSON
          data={layer.polygons}
          style={{ color: GeographyLayer.Colors[layer.type], dashArray: '5' }}
        >
          <Popup>
            <Typography>{t(GeographyLayer.Labels[layer.type])}</Typography>
            {layer?.province && <Typography>{i18n.language === LANGUAGE.TH ? layer.province_name : layer.province_name_en}</Typography>}
          </Popup>
        </GeoJSON>
      ))}
    </LayerOverlay>
  )
}

export default memo(OverlapAreaOverlay)
